import { render } from "./ImageOptimizerImage.vue?vue&type=template&id=671fd125&scoped=true"
import script from "./ImageOptimizerImage.vue?vue&type=script&lang=js"
export * from "./ImageOptimizerImage.vue?vue&type=script&lang=js"

import "./ImageOptimizerImage.vue?vue&type=style&index=0&id=671fd125&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671fd125"]])

export default __exports__